import { CountryCode } from '@doordash/lib-i18n'
import {
  COUNTRIES,
  COUNTRIES_WOLT_TRANSITION,
} from '@doordash/lib-validator-utils/dist/esm/constants'
import {
  SupportedCountryCode,
  SupportedCountryCodeForNewSignup,
} from '../models/types'

const FIVE_DIGITS_PATTERN = new RegExp(/^\d{5}$/)

export const getZipWithCountry = (
  zipCode: string,
  countryCode?: CountryCode
) => {
  let zipWithCountry = zipCode
  if (countryCode && COUNTRIES.hasOwnProperty(countryCode)) {
    zipWithCountry = `${zipCode} ${COUNTRIES[countryCode].name}`
  } else if (FIVE_DIGITS_PATTERN.test(zipCode)) {
    zipWithCountry = `${zipCode} ${COUNTRIES.US.name}`
  } else {
    const possibleZips = Object.values(COUNTRIES)
      .map(
        ({ name, zipcodePattern }) =>
          zipcodePattern.test(zipCode) && `${zipCode} ${name}`
      )
      .filter(c => c)
    if (possibleZips.length) {
      zipWithCountry = possibleZips[0]
    }
  }
  return zipWithCountry
}

export const getPossibleCountryCodesFromZip = (
  zipCode: string
): SupportedCountryCode[] =>
  Object.values(COUNTRIES)
    .map(
      ({ shortcode, zipcodePattern }) =>
        zipcodePattern.test(zipCode) && shortcode
    )
    .filter(c => c)

export const getPossibleCountryCodesFromZipForNewSignup = (
  zipCode: string
): SupportedCountryCodeForNewSignup[] =>
  Object.values(COUNTRIES_WOLT_TRANSITION)
    .map(
      ({ shortcode, zipcodePattern }) =>
        zipcodePattern.test(zipCode) && shortcode
    )
    .filter(c => c)

const noStandardization = (zipcode: string) => zipcode

function standardizeJPZip(zipcode: string): string {
  const match = zipcode.match(COUNTRIES.JP.zipcodePattern)
  if (match) {
    return `${match[1]}-${match[2]}`
  }
  return zipcode
}

const supportedCountryCodesToStandardizeZip: Record<
  SupportedCountryCode,
  (zipcode: string) => string
> = {
  US: noStandardization,
  PR: noStandardization,
  CA: noStandardization,
  AU: noStandardization,
  JP: standardizeJPZip,
  DE: noStandardization,
  NZ: noStandardization,
}

const newSignupSupportedCountryCodesToStandardizeZip: Record<
  SupportedCountryCodeForNewSignup,
  (zipcode: string) => string
> = {
  US: noStandardization,
  PR: noStandardization,
  CA: noStandardization,
  AU: noStandardization,
  DE: noStandardization,
  NZ: noStandardization,
}

export const standardizeZip = (
  zipcode: string,
  countryCode: SupportedCountryCode
): string => supportedCountryCodesToStandardizeZip[countryCode](zipcode)

export const newSignupstandardizeZip = (
  zipcode: string,
  countryCode: SupportedCountryCodeForNewSignup
): string =>
  newSignupSupportedCountryCodesToStandardizeZip[countryCode](zipcode)
